import { Event } from "./event";
import { Response } from "./response";
import { Status } from "./status";

export interface Transport {
  sendEvent(event: Event): PromiseLike<Response>;
}

export interface TransportOptions {
  endpoint: string;
}

export class NoopTransport implements Transport {
  sendEvent(_: Event): PromiseLike<Response> {
    return Promise.resolve({
      reason: `NoopTransport: Event has been skipped because no 'endpoint' is provided.`,
      status: Status.Skipped,
    });
  }
}
